require('es6-promise/auto');
import Vue        from 'vue'
import VueRouter  from 'vue-router'
import Axios      from 'axios'
import Storages   from 'js-storage'
import App        from './App.vue'
import AuthPlugin from './plugin/auth'
import Download   from '../node_modules/downloadjs/download.js'
// MuseUi component
import Mui_appBar       from 'muse-components/appBar'
import Mui_autoComplete from 'muse-components/autoComplete'
import Mui_badge        from 'muse-components/badge'
import Mui_checkbox     from 'muse-components/checkbox'
import Mui_circularProgress from 'muse-components/circularProgress'
import Mui_datePicker   from 'muse-components/datePicker'
import Mui_dialog       from 'muse-components/dialog'
import Mui_divider      from 'muse-components/divider'
import Mui_flatButton   from 'muse-components/flatButton'
import Mui_icon         from 'muse-components/icon'
import Mui_iconButton   from 'muse-components/iconButton'
import Mui_paper        from 'muse-components/paper'
import Mui_textField    from 'muse-components/textField'
import Mui_raisedButton from 'muse-components/raisedButton'
Vue.component(Mui_appBar.name, Mui_appBar)
Vue.component(Mui_autoComplete.name, Mui_autoComplete)
Vue.component(Mui_badge.name, Mui_badge)
Vue.component(Mui_checkbox.name, Mui_checkbox)
Vue.component(Mui_circularProgress.name, Mui_circularProgress)
Vue.component(Mui_datePicker.name, Mui_datePicker)
Vue.component(Mui_dialog.name, Mui_dialog)
Vue.component(Mui_divider.name, Mui_divider)
Vue.component(Mui_flatButton.name, Mui_flatButton)
Vue.component(Mui_icon.name, Mui_icon)
Vue.component(Mui_iconButton.name, Mui_iconButton)
Vue.component(Mui_paper.name, Mui_paper)
Vue.component(Mui_textField.name, Mui_textField)
Vue.component(Mui_raisedButton.name, Mui_raisedButton)

Object.defineProperty(Vue.prototype, '$download', { value: Download });

window.APP_COD = 'webdgt';
// Déclaration api Storage
window.ns = Storages
// Configuration Axios
//if (process.env.NODE_ENV === 'production') { console.log('bla'); } else { console.log('DEVVVV'); }
window.axios = Axios.create({
  baseURL: 'api', //  method: 'post', //withCredentials: true, //transformRequest: [(data) => JSON.stringify(data.data)],
  headers: {'Authorization': '0'},
  timeout: 15000
});

/**************** Routeur  **********************/
Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'hash',
  base: __dirname,
  routes: [
    { name: '', path: '/',          component: require('./page/Dashboard.vue') }, // all paths are defined without the hash.
    { name: '', path: '/dashboard', component: require('./page/Dashboard.vue') },
    { name: '', path: '/scan',      component: require('./page/Scan.vue') },
    { name: '', path: '/vouch',     component: () => import(/* webpackChunkName : "async" */ './page/Vouch.vue') },
    { name: '', path: '/vouch/:id', component: () => import(/* webpackChunkName : "async" */ './page/Vouch_card.vue') },
    { name: '', path: '/invoice',   component: () => import(/* webpackChunkName: "async" */ './page/Invoice.vue') },
    { name: 'Client', path: '/declaration',     component: () => import(/* webpackChunkName: "async" */ './page/Declaration.vue') },
    { name: 'Recep',  path: '/declaration/:id', component: () => import(/* webpackChunkName: "async" */ './page/Declaration.vue') },
    { name:'', path: '/map',         component: () => import(/* webpackChunkName: "async" */ './page/Map.vue') },
    { name:'', path: '/docrecep',    component: require('./page/Docrecep.vue') },

    { name:'address', path: '/address', component: () => import(/* webpackChunkName: "async" */ './page/Address.vue') },
    { name:'', path: '/driver',         component: require('./page/Driver.vue') },
    { path: '/driver/:id',              component: require('./page/Driver_card.vue') },
    { name:'', path: '/addressmanage',    component: () => import(/* webpackChunkName : "async" */ './page/Address_manage.vue') },
//    { path: '/user', component: Cuser },
//    { path: '/user/ajouter', component: CuserCard },
//    { path: '/user/:id', component: CuserCard },

    { name:'', path: '/pref',    component: require('./page/User_prefs.vue') },
    { name:'', path: '/report',  component: require('./page/Report.vue') },
    { name:'', path: '/login',   component: require('./component/Login.vue') },
    { name:'', path: '/loading', component: require('./component/Loading.vue') }
  ]
})
/**************** Authentification ******************/
router.beforeEach((to, from, next) => {
  var isSess  = ns.sessionStorage.isSet( APP_COD + '_token' )
  var isLocal = ns.localStorage.isSet( APP_COD + '_token' )
  if( isSess ){
    next()
  } else if ( isLocal ){
    next()
  } else if (to.path == '/login') {
    next()
  } else {
    next({ path: '/login' })
  }
})

Vue.use(AuthPlugin, {
  router: router
})

// Interceptor response *************************************
window.axios.interceptors.response.use(function (response) {
  return response
}, function (error) {

  if(error.response.status == 504){ // Pas de réponse serveur
    return Promise.reject(error)
  } else if ( vm.$auth.isLogin === true && error !== undefined && error.response.status == 401 ) {
    vm.$auth.lastReq = error.response.config //JSON.parse(error.response.config.data)
    vm.$auth.checkAuth( function(state){
      if( state ){
        router.push({ path: '/dashboard' })
      } else {
        router.push({ path: '/login' })
        return false //Promise.reject(error)
      }
    })
  } else {
    return Promise.reject(error)
  }
});
// Interceptor request **************************************
window.axios.interceptors.request.use(function (config) {
  if( !vm.$auth.isLogin && !vm.$auth.onAuth ){
    router.push({ path: '/login' })
  }
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

/**************** Application  **********************/
var vm = new Vue({
  router: router,
  el: '#app',
  data: {
    msg: "T"
  },
  beforeCreate: function(){
    var self = this
    window.axios.defaults.baseURL = this.$auth.userPref.baseURL
    this.$auth.checkAuth( function(result){
      if(!result){
        self.$router.push({ path: '/login' })
      }
    })
  },
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js